define(["exports", "react", "styled-components"], function (_exports, _react, _styledComponents) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);

  var MarkStyled = _styledComponents.default.span.withConfig({
    displayName: "Mark__MarkStyled",
    componentId: "sc-ifsywx-0"
  })(["background:", ";border-radius:50px;color:", ";font-family:", ";font-weight:", ";line-height:1.5;line-height:24px;padding:2px 5px 3px;", ""], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.red;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.white;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.font.primary;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.bold;
  }, function (_ref5) {
    var isValid = _ref5.isValid;
    return isValid && (0, _styledComponents.css)(["background:", ";"], function (_ref6) {
      var theme = _ref6.theme;
      return theme.colors.orange;
    });
  });

  var Mark = function Mark(_ref7) {
    var children = _ref7.children,
        secondaryRegex = _ref7.secondaryRegex,
        variables = _ref7.variables,
        hasVariables = _ref7.hasVariables;
    var child = children[0];
    var hasRegex = !!secondaryRegex;
    var variableExists = !!variables[child.props.text]; // if the user supplied variables, check if the variable name exists.
    // if they did not supply variables, check if they supplied a secondary regex to match against
    // if they did not then just default to trues

    var isValid = hasVariables ? variableExists : hasRegex ? secondaryRegex.exec(child.props.text) : true;
    return /*#__PURE__*/_react.default.createElement(MarkStyled, {
      isValid: isValid
    }, child);
  };

  var _default = Mark;
  _exports.default = _default;
  Mark.defaultProps = {
    theme: {}
  };
});